import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import FromSpFieldTextArea from '../../../atoms/FromSpFieldTextArea';
import { getAllocation, getTagChildCount, saveUnallocated } from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";

/* ─── Shared Asset List & Info CSS ─── */
import '../../ExcelUploads/AssetInfo/AssetInfo.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';

function getFormatedDate(dateString) {
    if (dateString) {
        let dte = new Date(dateString);
        if (isNaN(dte.getTime())) {
            return '';
        }
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
    } else {
        return '';
    }
}

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,500}$/;
const TEXT_SPCL_REGEX = /^[A-Za-z0-9-_.,\/\[\]\-()"'+&'%$#@*!= ]{1,500}$/;

function SingleNonAllocation() {
    const [tagCount, setTagCount] = useState('');
    const [assetInfo, setAssetInfo] = useState({});
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [tag, setTag] = useState('');
    const [ErrTag, setErrTag] = useState('');

    const [division, setDivision] = useState('');
    const [premises, setPremises] = useState('');
    const [floor, setFloor] = useState('');
    const [siteId, setSiteId] = useState('');
    const [userType, setUserType] = useState('');
    const [userDepartment, setUserDepartment] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [employeeName, setemployeeName] = useState('');

    const [dateUnallocation, setDateUnallocation] = useState('');
    const [ErrDateUnallocation, setErrDateUnallocation] = useState('');

    const [reason, setReason] = useState('');
    const [ErrReason, setErrReason] = useState('');

    const [assetinusedate, setAssetInuseDate] = useState('');
    const [childAllocation, setChildAllocation] = useState('');
    const [ErrChildAllocation, setErrChildAllocation] = useState('');
    const [auditInfo, setAuditInfo] = useState([]);

    const navigate = useNavigate();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');

    const resetAssetInfo = function () {
        setTag('');
        setDateUnallocation('');
        setReason('');
        setChildAllocation('');
    };

    const handleChildAllocation = (e) => {
        setChildAllocation(e.target.value);
    };

    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            try {
                const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptedTag = decrypt_data.tag;
                getTagAssetInfo(decryptedTag);
            } catch (err) {
                console.error("Error decrypting tag:", err);
            }
        } else {
            resetAssetInfo();
        }
    }, [Tag]);

    const getTagAssetInfo = function (decryptedTag) {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': decryptedTag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getAllocation(oData).then(function (res) {
            if (res?.data?.data?.assetInfo) {
                var aInfo = res.data.data.assetInfo;
                var aTranInfo = res.data.data.transferInfo;
                var aLogInfo = res.data.data.logInfo;
                setAssetInfo(aInfo);
                setTag(aInfo.tag);

                if (res.data.data?.logInfo && (aLogInfo.unallocate_date !== null) && (aLogInfo.unallocate_date > aInfo.asset_in_use_date)) {
                    setAssetInuseDate(aLogInfo.unallocate_date ? (new Date(aLogInfo.unallocate_date)) : '');
                } else {
                    setAssetInuseDate(aTranInfo?.effective_date ? (new Date(aTranInfo.effective_date)) : '');
                }
            }
            if (res?.data?.data?.transferInfo) {
                var Info = res.data.data.transferInfo;
                setAuditInfo(Info);
                setTag(Info.tag);
                setDivision(Info.division);
                setPremises(Info.premises);
                setFloor(Info.floor);
                setSiteId(Info.site_id);
                setUserType(Info.user_type);
                setUserDepartment(Info.user_department);
                setEmployeeId(Info.employee_id);
                setemployeeName(Info.employee_name);
                setDateUnallocation(Info.unallocate_date || '');
                setReason(Info.reason || '');
            }
        });

        getTagChildCount(oData).then(function (res) {
            const tagCount = res?.data?.data?.childTagCount?.tag_count || 0;
            setTagCount(tagCount);
            setChildAllocation(tagCount > 0 ? "Yes" : "No");
        });
    };

    const getTagInfo = function () {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData };

        getAllocation(oData1).then(function (res) {
            var aInfo = {};
            if (res?.data?.data?.assetInfo) {
                aInfo = res.data.data.assetInfo;
                var aLogInfo = res.data.data.logInfo;
                setAssetInfo(aInfo);
                setTag(aInfo.tag);
                if ((aLogInfo.unallocate_date !== null) && (aLogInfo.unallocate_date > aInfo.asset_in_use_date)) {
                    setAssetInuseDate(aLogInfo.unallocate_date ? (new Date(aLogInfo.unallocate_date)) : '');
                }
            } else {
                setAssetInfo({});
            }
            if (res?.data?.data?.transferInfo) {
                var Info = res.data.data.transferInfo;
                setAuditInfo(Info);
                setTag(Info.tag);
                setDivision(Info.division);
                setPremises(Info.premises);
                setFloor(Info.floor);
                setSiteId(Info.site_id);
                setUserType(Info.user_type);
                setUserDepartment(Info.user_department);
                setEmployeeId(Info.employee_id);
                setemployeeName(Info.employee_name);
                setDateUnallocation(Info.unallocate_date || '');
                setReason(Info.premises || '');
                setChildAllocation(Info.child_allocation || '');
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;

        if (!TEXT_REGEX.test(tag) && tag !== 0) {
            setErrTag('Tag is required');
            valid_Name = false;
        } else {
            setErrTag('');
        }
        if (!dateUnallocation) {
            setErrDateUnallocation('Date of Unallocation is required');
            valid_Name = false;
        } else {
            setErrDateUnallocation('');
        }
        if (!TEXT_SPCL_REGEX.test(reason)) {
            setErrReason('Reason is required');
            valid_Name = false;
        } else {
            setErrReason('');
        }

        if (valid_Name) {
            saveData();
        } else {
            return false;
        }
    };

    const saveData = function () {
        try {
            var obj = {
                'division': division,
                'premises': premises,
                'floor': floor,
                'site_id': siteId,
                'user_type': userType,
                'user_department': userDepartment,
                'employee_id': employeeId,
                'employee_name': employeeName,
                'tag': tag,
                'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                'unallocate_date': getFormatedDate(dateUnallocation),
                'child_allocation': childAllocation,
                'reason': reason,
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            };

            var objAudit = {
                'audit_module': 'Allocation', 'audit_method': 'unallocated',
                'audit_tag': tag, 'old_values': auditInfo, 'new_values': obj
            };

            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj, 'audit_params': objAudit,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };

            saveUnallocated(oData).then(function (res) {
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetAssetInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    };

    return (
        <div className="al-page" id="single-nonallocated-page">
            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon" style={{ background: 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)' }}>
                        <i className="bi bi-x-circle-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">UnAllocate Asset</h5>
                        <p className="al-page-subtitle">Unallocate asset and update record status</p>
                    </div>
                </div>
                <div className="al-record-badge">
                    <button className="al-btn al-btn-outline al-btn-sm" onClick={() => navigate(-1)} style={{ border: 'none', background: 'transparent', padding: 0 }}>
                        <i className="bi bi-arrow-left"></i> View Allocation List
                    </button>
                </div>
            </div>

            {/* Notifications */}
            {success && (
                <div className="alert alert-success mb-3" role="alert" style={{ borderRadius: '10px' }}>
                    <i className="bi bi-check-circle-fill me-2"></i>{success}
                </div>
            )}
            {errMsg && (
                <div className="alert alert-danger mb-3" role="alert" style={{ borderRadius: '10px' }}>
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>{errMsg}
                </div>
            )}

            {/* Tag Search Card (if no tag in query) */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="al-filter-card mb-3">
                    <div className="al-filter-card-header">
                        <span className="al-filter-card-title">
                            <i className="bi bi-tag-fill" /> Search Asset
                        </span>
                    </div>
                    <div className="al-filter-card-body">
                        <div className="al-filter-grid">
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">TAG <span className="al-required-star">*</span></label>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input
                                        type="text"
                                        className="al-form-input"
                                        placeholder="Enter the asset TAG"
                                        value={tag}
                                        onChange={(e) => setTag(e.target.value)}
                                        style={{ maxWidth: '300px' }}
                                    />
                                    <button onClick={getTagInfo} type="button" className="al-btn al-btn-primary">
                                        <i className="bi bi-search"></i> Search
                                    </button>
                                </div>
                                {ErrTag && <span className="al-field-error">{ErrTag}</span>}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ══ UNALLOCATE FORM CARD ══ */}
            <div className="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-journal-x" /> UNALLOCATION DETAILS
                    </span>
                    {tag && (
                        <span className="al-showing-badge">
                            TAG: <strong>{tag}</strong>
                        </span>
                    )}
                </div>

                <div style={{ padding: '24px' }}>
                    <form onSubmit={handleSubmit}>
                        <input type='hidden' name='tag' value={tag} />
                        <input type='hidden' name='division' value={division} />
                        <input type='hidden' name='premises' value={premises} />
                        <input type='hidden' name='floor' value={floor} />
                        <input type='hidden' name='site_id' value={siteId} />
                        <input type='hidden' name='user_type' value={userType} />
                        <input type='hidden' name='user_department' value={userDepartment} />
                        <input type='hidden' name='employee_id' value={employeeId} />
                        <input type='hidden' name='employee_name' value={employeeName} />

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromFieldText
                                    label="Tag"
                                    inputValue={assetInfo.tag ? assetInfo.tag : tag}
                                    readOnly="readonly"
                                />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromFieldDate
                                    star="*"
                                    minDate={assetinusedate}
                                    label="Date of Un Allocation"
                                    inputValue={dateUnallocation}
                                    setInputValue={setDateUnallocation}
                                    setErrorMsg={ErrDateUnallocation}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldTextArea
                                    maxLength="500"
                                    numRows="3"
                                    star="*"
                                    label="Reason for Unallocation"
                                    inputValue={reason}
                                    setInputValue={setReason}
                                    setErrorMsg={ErrReason}
                                />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label className="al-filter-label mb-2">Select for child Un-allocation</label>
                                    </div>
                                    <div class="col-md-6">
                                        <select
                                            onChange={handleChildAllocation}
                                            disabled={childAllocation !== "Yes"}
                                            name="childAllocation"
                                            className="al-form-select"
                                            value={childAllocation}
                                        >
                                            <option value="">Select for child allocation</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        {ErrChildAllocation && <span className="al-field-error">{ErrChildAllocation}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12" style={{ display: 'flex', gap: '12px', justifyContent: 'flex-start' }}>
                                <button type="submit" disabled={Boolean(success)} className="al-btn al-btn-primary" style={{ background: 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)', opacity: success ? 0.6 : 1, cursor: success ? 'not-allowed' : 'pointer' }}>
                                    <i className="bi bi-x-circle-fill"></i> UnAllocate
                                </button>
                                <a href={'/view-allocation'} className="al-btn al-btn-outline">
                                    <i className="bi bi-arrow-left"></i> Cancel
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SingleNonAllocation;
